/**
 * Copyright (c) Qwoach LLC 2024. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 17.11.24
 *
 */
import BaseObject from "@shared/BaseObject";

export default class DelayedAnalyticsManager extends BaseObject {

	constructor() {
		super()
		this._delayedEvents = []
	}

	trackEvent(...args) {
		this._delayedEvents.push({method: 'trackEvent', args})
	}

	trackAppEntry(...args) {
		this._delayedEvents.push({method: 'trackAppEntry', args})
	}

	trackPageView(...args) {
		this._delayedEvents.push({method: 'trackPageView', args})
	}

	trackUrlParams(...args) {
		this._delayedEvents.push({method: 'trackUrlParams', args})
	}

	setCohortVisitParams(...args) {
		this._delayedEvents.push({method: 'setCohortVisitParams', args})
	}


	flushEventsTo(analyticsManager) {
		this._delayedEvents.forEach(event => {
			console.log('DelayedAnalyticsManager.flushEventsTo', event)
			analyticsManager[event.method](...event.args)
		})
		this._delayedEvents = []
	}

}
